import APIService from 'services/APIService'

const api = APIService()

const avatarService = {
  upload: file => {
    const form = new FormData()
    form.append('avatar', file)
    return api.post('/me/avatar', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}

export default avatarService
